import $ from "jquery";
window.jQuery = $;
import slick from "slick-carousel";

$("a.burger").on("click", function (event) {
  event.preventDefault();
  $(".hamburger").toggleClass("is-active");
  $("nav").slideToggle(300);
  $(".search").slideUp(300);
  $(".clerks").slideUp(300);
  $(".portfolio").slideUp(300);
});

$(window).on("load", function () {
  $("ul.main > li").each(function () {
    if ($(this).children("ul").length > 0) {
      $(this).addClass("has-dropdown");
    }
  });
});

$("ul.main > li").on("click", function () {
  if ($(this).children("ul").length > 0) {
    $("nav ul li").not(this).removeClass("active");
    $(this).toggleClass("active");
    let ul = $(this).find("ul");
    let height = ul.height();

    if ($(window).width() > 1023) {
      $("nav").addClass("active");
  
    }

    if ($(window).width() > 639) {
      $("nav ul ul").not(ul).hide();
    } else {
      $("nav ul ul").not(ul).slideUp(300);
    }

    $("nav ul.main").css("min-height", `${height}px`);
    $("nav ul.main .rule").css("height", `${height}px`);

    if (ul.is(":visible")) {
      ul.slideUp(300);
      $("nav ul.main .rule").css("height", "0%");
      $("nav ul.main").css("min-height", `0`);
    } else {
      ul.slideDown(300);
    }
  }
});

$(window).on("load scroll resize", function () {
  let headerHeight = $("header > .container").outerHeight();
  $("nav").css("max-height", `calc(100vh - ${headerHeight}px)`);
  $(".portfolio").css("max-height", `calc(100vh - ${headerHeight}px)`);

  let heroHeight = $(".hero").length > 0 ? $(".hero").outerHeight() - 1 : 10;

 

  if ($(window).scrollTop() > heroHeight) {
    $("header").addClass("scroll");
  } else {
    $("header").removeClass("scroll");
  }

  if (!$("body").hasClass("home")) {
    let headerHeight =
      $(".sub-nav").length > 0
        ? $(".sub-nav").outerHeight(true) +
          $("header > .container:first").outerHeight()
        : $("header > .container:first").outerHeight();
    $("body").css("padding-top", `${headerHeight}px`);
  }
});

$("button#search").on("click", function (event) {
  $(".search").slideToggle(300);
  $("nav").slideUp(300);
  $(".clerks").slideUp(300);
  $(".hamburger").removeClass("is-active");
  $(".portfolio").slideUp(300);
});

$("button#portfolio").on("click", function (event) {
  $(".search").slideUp(300);
  $("nav").slideUp(300);
  $(".clerks").slideUp(300);
  $(".hamburger").removeClass("is-active");

  $(".portfolio").slideToggle(300);
});

$("#clerks-tab").on("click", function (event) {
  $(".search").slideUp(300);
  $("nav").slideUp(300);
  $(".hamburger").removeClass("is-active");
  $(".portfolio").slideUp(300);

  $(".clerks").slideToggle(300);
  $(".clerk-slider").slick("refresh");
});

$(".clerk-slider").slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  nextArrow: ".clerks .next svg",
  responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      },
    },
  ],
});
